import script from "./ValueGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueGraph.vue?vue&type=script&setup=true&lang=js"

import "./ValueGraph.vue?vue&type=style&index=0&id=bf082dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf082dae"]])

export default __exports__